import { AbstractControl } from '@angular/forms';
import { Constants } from '../util/Constants';

export class PrefLangValidator {
  static checkValue(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    if (Constants.VALID_PREF_LANG.indexOf(value) === -1) {
      return { 'invalidInput': { value } };
    }
    return null;
  }
}